<template>
  <div id="edit-tenant" v-if="payload.id">
    <label @click="$router.push({ name: 'platform-admin.tenants.index' })" class="back">
      <figure>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M9.57 5.93018L3.5 12.0002L9.57 18.0702M20.5 12.0002H3.67" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </figure>
      <p>Voltar</p>
    </label>
    <section class="photo">
      <h1>Logo do tenant</h1>
      <div class="data" :class="{ 'nophoto': !logoPreview && !payload.logo }">
        <div :style="{ backgroundImage: 'url(' + (logoPreview ? logoPreview : (payload.logo ? storageUrl + payload.logo : '')) + ')' }">
          <label class="tooltip" for="tenant-logo">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M23 19C23 19.5304 22.7893 20.0391 22.4142 20.4142C22.0391 20.7893 21.5304 21 21 21H3C2.46957 21 1.96086 20.7893 1.58579 20.4142C1.21071 20.0391 1 19.5304 1 19V8C1 7.46957 1.21071 6.96086 1.58579 6.58579C1.96086 6.21071 2.46957 6 3 6H7L9 3H15L17 6H21C21.5304 6 22.0391 6.21071 22.4142 6.58579C22.7893 6.96086 23 7.46957 23 8V19Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12 17C14.2091 17 16 15.2091 16 13C16 10.7909 14.2091 9 12 9C9.79086 9 8 10.7909 8 13C8 15.2091 9.79086 17 12 17Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </label>
        </div>
        <input autocomplete='off' type="file" accept="image/*" name="tenant-logo" id="tenant-logo" @change="handleLogoChange($event)">
        <p>A logo é exibida no menu do tenant para os usuários daquela conta.</p>
      </div>
    </section>
    <section class="double">
      <section>
        <h1><strong>Nome</strong> (obrigatório)</h1>
        <input type="text" placeholder="Ex: Prefeitura de Canindé" v-model="payload.name">
      </section>
      <section>
        <h1><strong>Sigla</strong></h1>
        <input type="text" placeholder="Ex: P.M.C" v-model="payload.acronym">
      </section>
    </section>
    <section>
      <h1><strong>Setor</strong> (obrigatório)</h1>
      <MySelect :name="'sector'" :for="'sector'" :currentValue="payload.sector ? tenantSectorLabels[payload.sector] : null">
        <li v-for="sector in Object.values(TenantSectorEnum)" :key="sector" @mousedown="payload.sector = sector">{{ tenantSectorLabels[sector] }}</li>
      </MySelect>
    </section>
    <section class="spacing">
      <h1><strong>Módulos</strong></h1>
      <h2>Controle quais funcionalidades pagas este tenant tem acesso.</h2>
      <div class="modules">
        <label class="module-toggle" v-for="module in Object.values(TenantModuleEnum)" :key="module">
          <input type="checkbox" :checked="payload.modules?.includes(module)" @change="toggleModule(module, ($event.target as HTMLInputElement).checked)">
          <span></span>
          <p>{{ tenantModuleLabels[module] }}</p>
        </label>
      </div>
    </section>
    <section class="spacing roles-section">
      <h1><strong>Perfis de acesso</strong></h1>
      <h2>Gerencie os perfis deste tenant e as permissões de cada um.</h2>
      <div class="roles-list" v-if="roles?.length">
        <div class="role-card" v-for="role in roles" :key="role.id">
          <template v-if="editingRoleId !== role.id">
            <div class="role-summary">
              <div>
                <h1>{{ role.name }}</h1>
                <h2>{{ role.permissions?.length ?? 0 }} permissões</h2>
              </div>
              <button class="tooltip" @click="startEditRole(role)">
                <figure>
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none">
                    <path fill='none' d="M13.2594 3.59924L5.04936 12.2892C4.73936 12.6192 4.43936 13.2692 4.37936 13.7192L4.00936 16.9592C3.87936 18.1292 4.71936 18.9292 5.87936 18.7292L9.09936 18.1792C9.54936 18.0992 10.1794 17.7692 10.4894 17.4292L18.6994 8.73924C20.1194 7.23924 20.7594 5.52924 18.5494 3.43924C16.3494 1.36924 14.6794 2.09924 13.2594 3.59924Z" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M11.89 5.05078C12.0996 6.39164 12.7486 7.62492 13.735 8.55703C14.7214 9.48914 15.9894 10.0673 17.34 10.2008M3 22.0008H21" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </figure>
              </button>
            </div>
          </template>
          <template v-else>
            <section>
              <input type="text" placeholder="Nome do perfil" v-model="editRolePayload.name">
            </section>
            <div class="permissions-grid">
              <label class="permission-chip" v-for="permission in permissions" :key="permission.id">
                <input type="checkbox" :checked="editRolePayload.permissionNames.includes(permission.name)" @change="toggleEditPermission(permission.name, ($event.target as HTMLInputElement).checked)">
                <span></span>
                <p>{{ permission.label }}</p>
              </label>
            </div>
            <div class="role-actions">
              <input v-if="!isSavingRole" type="button" value="Salvar" :disabled="!editRolePayload.name" @click="saveRoleEdit(role.id)">
              <SpinnerLoaderButton v-else :height="44" :maxWidth="140"/>
              <button class="cancel" @click="cancelRoleEdit">Cancelar</button>
            </div>
          </template>
        </div>
      </div>
      <h2 v-else-if="roles">Nenhum perfil cadastrado ainda.</h2>
      <SpinnerLoader v-else />
      <div class="add-role">
        <h2>Criar novo perfil</h2>
        <section>
          <input type="text" placeholder="Nome do perfil" v-model="newRole.name">
        </section>
        <div class="permissions-grid">
          <label class="permission-chip" v-for="permission in permissions" :key="permission.id">
            <input type="checkbox" :checked="newRole.permissionNames.includes(permission.name)" @change="toggleNewRolePermission(permission.name, ($event.target as HTMLInputElement).checked)">
            <span></span>
            <p>{{ permission.label }}</p>
          </label>
        </div>
        <input v-if="!isCreatingRole" type="button" value="Criar perfil" :disabled="!newRole.name" @click="createRole">
        <SpinnerLoaderButton v-else :height="55" :maxWidth="220"/>
      </div>
    </section>
    <section class="spacing users-section">
      <h1><strong>Usuários</strong></h1>
      <div class="users-list" v-if="users?.length">
        <div class="user-row doc-grid" v-for="tenantUser in users" :key="tenantUser.id">
          <label class="title">
            <h1>{{ tenantUser.name }} {{ tenantUser.last_name ?? '' }}</h1>
            <h2>{{ tenantUser.email }}</h2>
          </label>
          <label><h1>{{ tenantUser.roles[0]?.name ?? 'Sem role' }}</h1></label>
          <label><h1>{{ tenantUser.organization?.name ?? 'Sem organização' }}</h1></label>
          <label class="actions">
            <button class="tooltip" @click="userToImpersonate = tenantUser; isConfirmImpersonateModal = true">
              <figure>
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none">
                  <path d="M17.4417 14.62L20.0017 12.06L17.4417 9.5M9.76172 12.06H19.9317M11.7617 20C7.34172 20 3.76172 17 3.76172 12C3.76172 7 7.34172 4 11.7617 4" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </figure>
            </button>
          </label>
        </div>
      </div>
      <h2 v-else-if="users">Nenhum usuário cadastrado ainda.</h2>
      <SpinnerLoader v-else />
      <div class="add-user">
        <h2>Adicionar usuário</h2>
        <section class="double">
          <section>
            <input type="text" placeholder="Nome" v-model="newUser.name">
          </section>
          <section>
            <input type="text" placeholder="Sobrenome" v-model="newUser.last_name">
          </section>
        </section>
        <section class="double">
          <section>
            <input type="text" placeholder="E-mail" v-model="newUser.email">
          </section>
          <section>
            <input type="text" placeholder="Senha (mín. 6 caracteres)" v-model="newUser.password">
          </section>
        </section>
        <section class="double">
          <section>
            <MySelect v-if="roles" :name="'new-user-role'" :for="'new-user-role'" :currentValue="newUser.role ?? null">
              <li v-for="role in roles" :key="role.id" @mousedown="newUser.role = role.name">{{ role.name }}</li>
            </MySelect>
          </section>
          <section>
            <MySelect v-if="organizations" :name="'new-user-organization'" :for="'new-user-organization'" :currentValue="newUser.organizationName ?? 'Nenhuma'">
              <li @mousedown="newUser.organizationId = undefined; newUser.organizationName = 'Nenhuma'">Nenhuma</li>
              <li v-for="organization in organizations" :key="organization.id" @mousedown="newUser.organizationId = organization.id; newUser.organizationName = organization.name">{{ organization.name }}</li>
            </MySelect>
          </section>
        </section>
        <input v-if="!isAddingUser" type="button" value="Adicionar usuário" :disabled="!canAddUser" @click="addUser">
        <SpinnerLoaderButton v-else :height="55" :maxWidth="220"/>
      </div>
    </section>
    <nav>
      <input v-if="!isUpdatingTenant" type="button" value="Salvar" :disabled="!payload.name || !payload.sector" @click="updateTenant">
      <SpinnerLoaderButton v-else :height="60" :maxWidth="464"/>
      <input type="button" value="Cancelar" @click="$router.push({ name: 'platform-admin.tenants.index' })">
    </nav>
    <MyModal :width="'360px !important'" :height="'320px !important'" :isOpen="isConfirmImpersonateModal" :class-name="'confirm-impersonate'" :toggleModal="(v: boolean) => isConfirmImpersonateModal = v" :zIndex="100">
      <div>
        <svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 24 24" fill="none">
          <path d="M17.4417 14.62L20.0017 12.06L17.4417 9.5M9.76172 12.06H19.9317M11.7617 20C7.34172 20 3.76172 17 3.76172 12C3.76172 7 7.34172 4 11.7617 4" stroke="#E1793E" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <h1>Atenção!</h1>
        <h2>Você vai entrar como <strong>{{ userToImpersonate?.name }} {{ userToImpersonate?.last_name }}</strong> ({{ userToImpersonate?.email }}). Essa ação fica registrada.</h2>
        <section>
          <button @click="isConfirmImpersonateModal = false; impersonate()">Sim, entrar</button>
          <input autocomplete="off" @click="isConfirmImpersonateModal = false" type="button" value="Cancelar">
        </section>
      </div>
    </MyModal>
  </div>
  <SpinnerLoader v-else />
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import MySelect from '@/components/select/MySelect.vue'
import MyModal from '@/components/modal/MyModal.vue'
import { useAxios } from '@/api/axios'
import { AxiosResponse } from 'axios'
import { TenantModel } from '@/models/TenantModel'
import { TenantSectorEnum, tenantSectorLabels } from '@/enums/Tenants/TenantSectorEnum'
import { TenantModuleEnum, tenantModuleLabels } from '@/enums/Tenants/TenantModuleEnum'
import SpinnerLoader from '@/components/loader/SpinnerLoader.vue'
import SpinnerLoaderButton from '@/components/loader/SpinnerLoaderButton.vue'
import { toast } from 'vue3-toastify'
import { storageUrl } from '@/global/states/GlobalState'

interface PermissionOption {
  id: number
  name: string
  label: string
}

interface TenantRole {
  id: number
  name: string
  permissions?: PermissionOption[]
}

interface TenantOrganization {
  id: number
  name: string
  acronym: string
}

interface TenantUser {
  id: number
  name: string
  last_name: string | null
  email: string
  status: string
  organization_id: number | null
  roles: TenantRole[]
  organization: { id: number; name: string } | null
}

interface TenantShowResponse {
  tenant: TenantModel
  roles: TenantRole[]
  organizations: TenantOrganization[]
  users: TenantUser[]
}

const props = defineProps<{ id: number }>()
const axios = useAxios()
const payload = ref<Partial<TenantModel>>({ modules: [] })
const logoPreview = ref<string>('')
const isUpdatingTenant = ref(false)
const roles = ref<TenantRole[]>()
const organizations = ref<TenantOrganization[]>()
const users = ref<TenantUser[]>()
const isAddingUser = ref(false)
const newUser = ref<{ name?: string, last_name?: string, email?: string, password?: string, role?: string, organizationId?: number, organizationName?: string }>({})
const canAddUser = computed(() => {
  return !!(newUser.value.name && newUser.value.last_name && newUser.value.email && newUser.value.password && newUser.value.password.length >= 6 && newUser.value.role)
})
const isConfirmImpersonateModal = ref(false)
const userToImpersonate = ref<TenantUser>()

const permissions = ref<PermissionOption[]>()
const newRole = ref<{ name?: string, permissionNames: string[] }>({ permissionNames: [] })
const isCreatingRole = ref(false)
const editingRoleId = ref<number>()
const editRolePayload = ref<{ name?: string, permissionNames: string[] }>({ permissionNames: [] })
const isSavingRole = ref(false)

onMounted(() => {
  fetchTenant()
  fetchPermissions()
})

function fetchTenant () {
  axios.get(`/api/platform-admin/tenants/${props.id}`)
    .then((res: AxiosResponse<TenantShowResponse>) => {
      payload.value = { ...res.data.tenant, modules: res.data.tenant.modules ?? [] }
      roles.value = res.data.roles
      organizations.value = res.data.organizations
      users.value = res.data.users
    })
}

function fetchPermissions () {
  axios.get('/api/platform-admin/permissions')
    .then((res: AxiosResponse<PermissionOption[]>) => {
      permissions.value = res.data
    })
}

function toggleNewRolePermission (name: string, checked: boolean) {
  const set = new Set(newRole.value.permissionNames)
  checked ? set.add(name) : set.delete(name)
  newRole.value.permissionNames = Array.from(set)
}

function createRole (): void {
  isCreatingRole.value = true

  const formData = new FormData()
  formData.append('name', newRole.value.name!)
  newRole.value.permissionNames.forEach((name, index) => {
    formData.append(`permissions[${index}]`, name)
  })

  axios.post(`/api/platform-admin/tenants/${props.id}/roles`, formData)
    .then(() => {
      toast.success('Perfil criado com sucesso')
      newRole.value = { permissionNames: [] }
      roles.value = undefined
      fetchTenant()
    })
    .finally(() => isCreatingRole.value = false)
}

function startEditRole (role: TenantRole) {
  editingRoleId.value = role.id
  editRolePayload.value = {
    name: role.name,
    permissionNames: (role.permissions ?? []).map((permission) => permission.name)
  }
}

function cancelRoleEdit () {
  editingRoleId.value = undefined
}

function toggleEditPermission (name: string, checked: boolean) {
  const set = new Set(editRolePayload.value.permissionNames)
  checked ? set.add(name) : set.delete(name)
  editRolePayload.value.permissionNames = Array.from(set)
}

function saveRoleEdit (roleId: number): void {
  isSavingRole.value = true

  const formData = new FormData()
  formData.append('name', editRolePayload.value.name!)
  formData.append('permissions_provided', '1')
  editRolePayload.value.permissionNames.forEach((name, index) => {
    formData.append(`permissions[${index}]`, name)
  })

  axios.patch(`/api/platform-admin/tenants/${props.id}/roles/${roleId}`, formData)
    .then(() => {
      toast.success('Perfil atualizado com sucesso')
      editingRoleId.value = undefined
      roles.value = undefined
      fetchTenant()
    })
    .finally(() => isSavingRole.value = false)
}

function addUser (): void {
  isAddingUser.value = true

  const formData = new FormData()
  formData.append('name', newUser.value.name!)
  formData.append('last_name', newUser.value.last_name!)
  formData.append('email', newUser.value.email!)
  formData.append('password', newUser.value.password!)
  formData.append('role', newUser.value.role!)
  if (newUser.value.organizationId) {
    formData.append('organization_id', String(newUser.value.organizationId))
  }

  axios.post(`/api/platform-admin/tenants/${props.id}/users`, formData)
    .then(() => {
      toast.success('Usuário adicionado com sucesso')
      newUser.value = {}
      users.value = undefined
      fetchTenant()
    })
    .finally(() => isAddingUser.value = false)
}

function impersonate (): void {
  if (!userToImpersonate.value) return

  axios.post(`/api/platform-admin/users/${userToImpersonate.value.id}/impersonate`)
    .then(() => {
      window.location.href = '/admin/home'
    })
}

function handleLogoChange (event: Event) {
  const input = event.target as HTMLInputElement
  const file: File | null = input.files && input.files[0]
  if (file) {
    payload.value.logo = file
    logoPreview.value = URL.createObjectURL(file)
  }
}

function toggleModule (module: TenantModuleEnum, checked: boolean) {
  const modules = new Set(payload.value.modules ?? [])
  if (checked) {
    modules.add(module)
  } else {
    modules.delete(module)
  }
  payload.value.modules = Array.from(modules)
}

function updateTenant (): void {
  isUpdatingTenant.value = true

  const formData = new FormData()
  formData.append('name', payload.value.name!)
  if (payload.value.acronym) {
    formData.append('acronym', payload.value.acronym)
  }
  formData.append('sector', payload.value.sector!)
  if (payload.value.logo instanceof File) {
    formData.append('logo', payload.value.logo)
  }
  formData.append('modules_provided', '1')
  const modules = payload.value.modules ?? []
  modules.forEach((module, index) => {
    formData.append(`modules[${index}]`, module)
  })

  axios.patch(`/api/platform-admin/tenants/${props.id}`, formData)
    .then((res: AxiosResponse<TenantModel>) => {
      payload.value = { ...res.data, modules: res.data.modules ?? [] }
      logoPreview.value = ''
      toast.success('Tenant editado com sucesso')
    })
    .finally(() => isUpdatingTenant.value = false)
}
</script>

<style lang="scss">
  #edit-tenant{
    width: 100%;
    max-width: 1200px;
    display: flex;
    flex-direction: column;
    align-items: start;
    row-gap: 28px;
    section{
      width: 100%;
      display: flex;
      flex-direction: column;
      position: relative;
      &.double{
        display: flex;
        flex-direction: row;
        column-gap: 20px;
      }
      h1{
        color: #090909;
        font-family: 'Inter', sans-serif;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin: 0 0 13px 0;
        text-align: start;
        strong{
          color: #090909;
          font-family: 'Inter', sans-serif;
          font-size: 20px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
        }
      }
      h2{
        color: #6F6F6F;
        font-family: 'Inter', sans-serif;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        text-align: start;
        margin: -13px 0 13px 0;
      }
      input[type="text"]{
        width: 100%;
        height: 55px;
        border-radius: 14px;
        border: 1px solid #D3D3D3;
        color: $fluxoo-primary-color;
        font-family: 'Inter', sans-serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        padding: 15px 20px;
        box-sizing: border-box;
        transition: border-color .2s, color .2s, background .2s;
        &:focus{
          outline: none;
        }
        &::placeholder{
          color: #090909;
          font-family: 'Inter', sans-serif;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
        }
      }
      &.photo{
        row-gap: 13px;
        margin: 0 0 20px 0;
        animation: enterContent ease .4s;
        h1{
          font-size: 20px;
          font-weight: 700;
          margin: 0;
        }
        input{
          display: none;
        }
        .data{
          display: flex;
          align-items: center;
          column-gap: 24px;
          &.nophoto{
            div{
              position: relative;
              display: flex;
              flex-direction: column;
              align-items: center;
              &::before{
                content: 'logo do tenant';
                color: #6F6F6F;
                text-align: center;
                font-family: 'Inter', sans-serif;
                font-size: 13px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
                position: absolute;
                top: 65px;
              }
            }
          }
          > div{
            width: 170px;
            min-width: 170px;
            height: 170px;
            min-height: 170px;
            display: flex;
            justify-content: center;
            border-radius: 50%;
            background: #F1F1F1;
            background-position: center 0;
            background-size: cover;
            background-repeat: no-repeat;
            label{
              width: 45px;
              min-width: 45px;
              height: 45px;
              min-height: 45px;
              display: flex;
              border-radius: 50%;
              background: #FFF;
              align-items: center;
              justify-content: center;
              margin: 100px 0 0 0;
              transition: background .2s;
              cursor: pointer;
              filter: drop-shadow(0px 0px 25px rgba(0, 0, 0, 0.12));
              &:hover{
                background: $fluxoo-primary-color;
                svg{
                  stroke: #FFF;
                }
              }
              svg{
                width: 24px;
                min-width: 24px;
                height: 24px;
                stroke: #090909;
                margin: auto auto;
                transition: stroke .2s;
              }
            }
          }
          p{
            color: #6F6F6F;
            font-family: 'Inter', sans-serif;
            font-size: 13px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            max-width: 300px;
            text-align: start;
            margin: 0;
          }
        }
      }
      .modules{
        display: flex;
        flex-direction: column;
        row-gap: 16px;
        .module-toggle{
          width: fit-content;
          display: flex;
          align-items: center;
          column-gap: 12px;
          cursor: pointer;
          input{
            display: none;
            &:checked{
              & ~ span{
                background: $fluxoo-primary-color-hover;
                &::before{
                  background: $fluxoo-primary-color;
                  left: calc(100% - 25px);
                }
              }
            }
          }
          span{
            width: 43px;
            min-width: 43px;
            height: 11px;
            background: #949494;
            border-radius: 12px;
            position: relative;
            transition: background .2s;
            &::before{
              content: '';
              width: 25px;
              height: 25px;
              background: #D5D5D5;
              border-radius: 50%;
              position: absolute;
              top: -7px;
              left: 0;
              transition: background .2s, left .2s;
            }
          }
          p{
            color: #090909;
            font-family: 'Inter', sans-serif;
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
            margin: 0;
          }
        }
      }
      &.roles-section{
        > h2{
          margin: -13px 0 20px 0;
        }
        .roles-list{
          width: 100%;
          display: flex;
          flex-direction: column;
          row-gap: 10px;
          margin: 0 0 24px 0;
          .role-card{
            width: 100%;
            border-radius: 24px;
            border: 1px solid #D3D3D3;
            background: #FFF;
            box-sizing: border-box;
            animation: enterContent ease-in-out .6s;
            padding: 20px 24px;
            display: flex;
            flex-direction: column;
            row-gap: 20px;
            .role-summary{
              width: 100%;
              display: flex;
              align-items: center;
              justify-content: space-between;
              div{
                h1{
                  color: #090909;
                  font-family: 'Inter', sans-serif;
                  font-size: 16px;
                  font-style: normal;
                  font-weight: 500;
                  line-height: normal;
                  margin: 0;
                  text-align: start;
                }
                h2{
                  color: #6F6F6F;
                  font-family: 'Inter', sans-serif;
                  font-size: 13px;
                  font-style: normal;
                  font-weight: 500;
                  line-height: normal;
                  margin: 6px 0 0 0;
                }
              }
              button{
                width: 24px;
                min-width: 24px;
                height: 24px;
                min-height: 24px;
                cursor: pointer;
                figure{
                  width: 100%;
                  height: 100%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  margin: 0;
                }
                svg{
                  width: 22px;
                  min-width: 22px;
                  height: 22px;
                  min-height: 22px;
                  stroke: #090909;
                  transition: stroke .2s;
                }
                &:hover svg{
                  stroke: $fluxoo-primary-color;
                }
                &::before{
                  content: 'Editar';
                  width: 60px;
                }
              }
            }
            .role-actions{
              display: flex;
              align-items: center;
              column-gap: 20px;
              input[type='button']{
                width: fit-content;
                height: 44px;
                padding: 0 24px;
                border: none;
                border-radius: 14px;
                background: $fluxoo-primary-color;
                color: #FFF;
                font-family: 'Inter', sans-serif;
                font-size: 14px;
                font-style: normal;
                font-weight: 600;
                line-height: normal;
                cursor: pointer;
                transition: background .2s;
                &:hover{
                  background: $fluxoo-primary-color-hover;
                }
                &:disabled{
                  background: #F1F1F1 !important;
                  color: #6F6F6F !important;
                  cursor: not-allowed !important;
                }
              }
              button.cancel{
                color: #737373;
                font-family: 'Inter', sans-serif;
                font-size: 14px;
                font-style: normal;
                font-weight: 600;
                line-height: normal;
                cursor: pointer;
                transition: color .2s;
                &:hover{
                  color: $fluxoo-primary-color;
                }
              }
            }
          }
        }
        .permissions-grid{
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin: 0 0 4px 0;
          .permission-chip{
            width: fit-content;
            display: flex;
            align-items: center;
            column-gap: 8px;
            padding: 10px 16px;
            border-radius: 20px;
            border: 1px solid #D3D3D3;
            cursor: pointer;
            transition: border-color .2s, background .2s;
            input{
              display: none;
              &:checked ~ span{
                background: $fluxoo-primary-color;
                border-color: $fluxoo-primary-color;
                &::before{
                  content: '';
                  width: 4px;
                  height: 8px;
                  border-right: 2px solid #FFF;
                  border-bottom: 2px solid #FFF;
                  position: absolute;
                  top: 1px;
                  left: 4px;
                  transform: rotate(45deg);
                }
              }
            }
            span{
              width: 16px;
              min-width: 16px;
              height: 16px;
              min-height: 16px;
              border-radius: 4px;
              border: 1px solid #6F6F6F;
              position: relative;
              transition: border-color .2s, background .2s;
            }
            p{
              color: #090909;
              font-family: 'Inter', sans-serif;
              font-size: 14px;
              font-style: normal;
              font-weight: 500;
              line-height: normal;
              margin: 0;
            }
          }
        }
        .add-role{
          width: 100%;
          display: flex;
          flex-direction: column;
          row-gap: 16px;
          padding: 24px;
          border-radius: 24px;
          background: #F5F8F7;
          box-sizing: border-box;
          > h2{
            color: #090909;
            font-family: 'Inter', sans-serif;
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            margin: 0;
          }
          input[type='button']{
            width: 100%;
            max-width: 220px;
            height: 55px;
            border: none;
            border-radius: 30px;
            background: $fluxoo-primary-color;
            color: #FFF;
            text-align: center;
            font-family: 'Inter', sans-serif;
            font-size: 15px;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
            transition: background .2s;
            cursor: pointer;
            &:hover{
              background: $fluxoo-primary-color-hover;
            }
            &:disabled{
              background: #F1F1F1 !important;
              color: #6F6F6F !important;
              cursor: not-allowed !important;
            }
          }
        }
      }
      &.users-section{
        > h2{
          margin: -13px 0 20px 0;
        }
        .users-list{
          width: 100%;
          display: flex;
          flex-direction: column;
          row-gap: 10px;
          margin: 0 0 24px 0;
          .user-row{
            width: 100%;
            display: grid;
            grid-template-columns: 1fr 200px 220px 44px;
            column-gap: 15px;
            align-items: center;
            padding: 20px 24px;
            border-radius: 24px;
            border: 1px solid #D3D3D3;
            background: #FFF;
            box-sizing: border-box;
            animation: enterContent ease-in-out .6s;
            label{
              display: flex;
              flex-direction: column;
              align-items: start;
              h1{
                color: #090909;
                font-family: 'Inter', sans-serif;
                font-size: 16px;
                font-style: normal;
                font-weight: 500;
                line-height: normal;
                margin: 0;
                text-align: start;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
              }
              h2{
                color: #6F6F6F;
                font-family: 'Inter', sans-serif;
                font-size: 13px;
                font-style: normal;
                font-weight: 500;
                line-height: normal;
                margin: 6px 0 0 0;
              }
              &.actions{
                button{
                  width: 24px;
                  min-width: 24px;
                  height: 24px;
                  min-height: 24px;
                  cursor: pointer;
                  figure{
                    width: 100%;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin: 0;
                  }
                  svg{
                    width: 22px;
                    min-width: 22px;
                    height: 22px;
                    min-height: 22px;
                    stroke: #090909;
                    transition: stroke .2s;
                  }
                  &:hover svg{
                    stroke: $fluxoo-primary-color;
                  }
                  &::before{
                    content: 'Entrar como';
                    width: 90px;
                    right: -5px;
                  }
                }
              }
            }
          }
        }
        .add-user{
          width: 100%;
          display: flex;
          flex-direction: column;
          row-gap: 16px;
          padding: 24px;
          border-radius: 24px;
          background: #F5F8F7;
          box-sizing: border-box;
          > h2{
            color: #090909;
            font-family: 'Inter', sans-serif;
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            margin: 0;
          }
          input[type='button']{
            width: 100%;
            max-width: 220px;
            height: 55px;
            border: none;
            border-radius: 30px;
            background: $fluxoo-primary-color;
            color: #FFF;
            text-align: center;
            font-family: 'Inter', sans-serif;
            font-size: 15px;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
            transition: background .2s;
            cursor: pointer;
            &:hover{
              background: $fluxoo-primary-color-hover;
            }
          }
        }
      }
    }
    nav{
      width: 100%;
      max-width: 1200px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 15px 32px;
      border-radius: 16px;
      background: #FFF;
      box-shadow: 0px 0px 25px 0px rgba(0, 0, 0, 0.12);
      box-sizing: border-box;
      position: sticky;
      bottom: 5px;
      column-gap: 20px;
      margin: auto 0 0 0;
      input{
        border: none;
        cursor: pointer;
        &:first-child{
          width: 100%;
          max-width: 464px;
          height: 60px;
          border-radius: 30px;
          background: $fluxoo-primary-color;
          color: #FFF;
          text-align: center;
          font-family: 'Inter', sans-serif;
          font-size: 16px;
          font-style: normal;
          font-weight: 600;
          line-height: normal;
          transition: background .2s;
          &:hover{
            background: $fluxoo-primary-color-hover;
          }
        }
        &:last-child{
          color: #737373;
          font-family: 'Inter', sans-serif;
          font-size: 16px;
          font-style: normal;
          font-weight: 600;
          line-height: normal;
          background: unset;
          transition: color .2s;
          &:hover{
            color: $fluxoo-primary-color;
          }
        }
      }
    }
    .modal{
      &.confirm-impersonate{
        div{
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 26px 15px 24px;
          box-sizing: border-box;
          svg{
            margin: 0 0 4px 0;
          }
          h1{
            color: #090909;
            font-family: 'Nunito', sans-serif;
            font-size: 28px;
            font-style: normal;
            font-weight: 900;
            line-height: normal;
            margin: 2px 0 7px 0;
          }
          h2{
            color: #6F6F6F;
            text-align: center;
            font-family: 'Inter', sans-serif;
            font-size: 15px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            margin: 0;
            strong{
              color: #090909;
              font-weight: 700;
            }
          }
          section{
            width: 100%;
            display: flex;
            align-items: center;
            flex-direction: row;
            justify-content: space-between;
            padding: 0;
            margin: 24px 0 0 0;
            button{
              height: 30px;
              width: 80px;
              color: #090909;
              font-family: 'Inter', sans-serif;
              font-size: 18px;
              font-style: normal;
              font-weight: 500;
              line-height: 18px;
              display: flex;
              justify-content: center;
              align-items: center;
              transition: color .2s;
              cursor: pointer;
              &:hover{
                color: $fluxoo-primary-color;
              }
            }
            input{
              height: 55px;
              border-radius: 30px;
              background: #090909;
              color: #FFF;
              font-family: 'Inter', sans-serif;
              font-size: 16px;
              font-style: normal;
              font-weight: 500;
              line-height: normal;
              border: none;
              width: 165px;
              cursor: pointer;
              transition: background .2s;
              &:hover{
                background: $fluxoo-primary-color;
              }
            }
          }
        }
      }
    }
  }

  @media(max-width: 700px){
    #edit-tenant{
      .users-section{
        .users-list{
          .user-row{
            grid-template-columns: 1fr;
            row-gap: 10px;
          }
        }
        .add-user{
          section.double{
            flex-direction: column !important;
            row-gap: 28px;
          }
        }
      }
    }
  }

  @media(max-width: 425px){
    #edit-tenant{
      nav{
        animation: enterToBottom ease 0.9s;
        width: 100vw;
        position: fixed;
        left: 0;
        bottom: 0;
        border-radius: 20px 20px 0px 0px;
        background: #FFF;
        box-shadow: 0px 0px 25px 0px rgba(0, 0, 0, 0.12);
        padding: 15px;
        box-sizing: border-box;
        z-index: 4;
      }
    }
  }
</style>
